import { render, staticRenderFns } from "./patientinfocard.vue?vue&type=template&id=6dba2013&scoped=true"
import script from "./patientinfocard.vue?vue&type=script&lang=js"
export * from "./patientinfocard.vue?vue&type=script&lang=js"
import style0 from "./patientinfocard.vue?vue&type=style&index=0&id=6dba2013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba2013",
  null
  
)

export default component.exports